<ng-container [ngSwitch]="currentStep">
    <div class="stepper-header">
        <div class="stepper-header-title">
            <span>{{ sectionTitle }}</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="progress" color="primary"></mat-progress-bar>
    </div>
    <lgv-stated-income class="step-body" *ngSwitchCase="PreApprovalSteps.StatedIncome" (stepChange)="goToStep($event)"
        (sectionChange)="goToSection($event)"></lgv-stated-income>
    <lgv-purchase-price class="step-body" *ngSwitchCase="PreApprovalSteps.PurchasePrice" (stepChange)="goToStep($event)"
        (sectionChange)="goToSection($event)"></lgv-purchase-price>
    <lgv-down-payment class="step-body" *ngSwitchCase="PreApprovalSteps.DownPayment" (stepChange)="goToStep($event)"
        (sectionChange)="goToSection($event)"></lgv-down-payment>
</ng-container>